import React from 'react';
import PropTypes from 'prop-types';
import trendingMock from './trending-mock.json';
import FireIcon from '@tradera/tradera-ui/icons/fire.svg?jsx';
import TagIcon from '@tradera/tradera-ui/icons/tag.svg?jsx';
import { Analytics } from 'packages';
import './trending-tags.scss';

const TrendingTags = ({ initData }) => {
    const handleTagClick = label => {
        Analytics.trackEvent({
            category: 'Search',
            action: 'Navigation',
            label: label
        });
    };

    const {
        featureSwitches,
        trendingBrands = [],
        trendingSearches = []
    } = initData;

    const {
        searches: trendingSearchesMock,
        brands: trendingBrandsMock
    } = trendingMock;

    const useApi = featureSwitches['start-page-content-integration'];
    const contentFetched =
        trendingBrands.length > 0 && trendingSearches.length > 0;

    if (useApi && !contentFetched) {
        return null;
    }

    const Tag = ({ name, categoryId, icon, url }) => (
        <a
            type="button"
            className="btn btn-outline-primary btn-sm mr-3 my-2 trending-tag"
            onClick={() => {
                handleTagClick(name);
            }}
            href={
                url
                    ? url
                    : `/search?categoryId=${categoryId}&q=${name}&sortBy=MostBids`
            }>
            {icon}
            <span className="ml-2">{name}</span>
        </a>
    );

    const renderSearches = (trendingSearches, trendingSearchesMock) => {
        const searches = useApi ? trendingSearches : trendingSearchesMock;
        return searches.map((searchTerm, index) => {
            const { query, categoryId } = searchTerm;
            return (
                <Tag
                    name={query}
                    categoryId={categoryId}
                    icon={<FireIcon className="icon icon-sm" />}
                    key={`${query}-${index}`}
                />
            );
        });
    };

    const renderBrands = (trendingBrands, trendingBrandsMock) => {
        const brands = useApi ? trendingBrands : trendingBrandsMock;
        return brands.map((brand, index) => {
            const { name, categoryId, slug } = brand;
            return (
                <Tag
                    name={name}
                    categoryId={categoryId}
                    icon={<TagIcon className="icon icon-sm icon-primary" />}
                    key={`${name}-${index}`}
                    url={slug ? `/brand/${slug}` : slug}
                />
            );
        });
    };

    return (
        <div className="row">
            <div className="col-md-6 col-12 pb-md-0 pb-3">
                <h3 className="text-branded">
                    Populära varumärken
                    <span className="d-inline d-md-none">:</span>
                </h3>
                <div className="tag-wrapper py-2">
                    {renderBrands(trendingBrands, trendingBrandsMock)}
                </div>
            </div>
            <div className="col-md-6 col-12">
                <h3 className="text-branded">
                    Trendande sökningar
                    <span className="d-inline d-md-none">:</span>
                </h3>
                <div className="tag-wrapper tags-searches py-2">
                    {renderSearches(trendingSearches, trendingSearchesMock)}
                </div>
            </div>
        </div>
    );
};

TrendingTags.propTypes = {
    initData: PropTypes.object.isRequired
};

export default TrendingTags;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/trending/trending-tags.jsx